import type { SortConfig, SortKey } from '@/lib/merge-stream/types'
import { SortableHeader } from '@/lib/table-utils'
import { useTranslations } from 'next-intl'

type EventTableHeaderProps = {
	sort: SortConfig
	onSort: (key: SortKey) => void
}

export function EventTableHeader({ sort, onSort }: EventTableHeaderProps) {
	const t = useTranslations('explore')
	return (
		<thead className="sticky top-0 z-10 border-b border-b-[#282A2C] bg-brand-dark-light">
			<tr className="rounded-tl-[12px] rounded-tr-[12px]">
				<th className="min-w-[350px] p-[16px] text-left font-normal text-[14px] text-white/75 leading-[100%]">
					{t('events')}
				</th>
				<th className="w-[90px] p-[16px] text-right font-normal text-[14px] text-white/75 leading-[100%]">
					<SortableHeader
						label={t('volume')}
						sortKey="volume"
						currentSort={sort}
						className="!font-grotesk !text-[14px]"
						onSort={onSort}
					/>
				</th>
				<th className="w-[90px] p-[16px] text-right font-normal text-[14px] text-white/75 leading-[100%]">
					<SortableHeader
						label={t('liquidity')}
						sortKey="liquidity"
						currentSort={sort}
						className="!font-grotesk !text-[14px]"
						onSort={onSort}
					/>
				</th>
				<th className="w-[240px] p-[16px] text-left font-normal text-[14px] text-white/75 leading-[100%]">
					{t('expires')}
				</th>
				<th className="w-[140px] p-[16px] text-left font-normal text-[14px] text-white/75 leading-[100%]">
					{t('trade')}
				</th>
			</tr>
		</thead>
	)
}
